import Photo from './Photo/Photo';
import photos from './Photo/data';
import advantages from './advantages';
import Products from './Products/Products';
import Presentation from './Presentation/Presentation';
import Grid from '../../components/Grid/Grid';
import { Helmet } from "react-helmet-async";
import './Main.scss';

const HelmetAny = Helmet as unknown as React.ComponentType<any>;

const Main: React.FC = () => {
    return (
        <>
            <HelmetAny>
                <link rel="icon" href="./favicon.png" />
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <meta name="theme-color" content="#000000" />
                <meta name="description"
                    content="Ommatid — инновационные решения обеспечения безопасности в местах массового скопления людей" />
                <meta name="keywords"
                    content="Ommatid, Системы безопасности, комплексная система обеспечения безопасности, новейшие средства для панорамного  видеонаблюдения" />

                <meta property="og:title" content="Ommatid — инновационные решения в области видеонаблюдения" />
                <meta property="og:description" content="Передовые технологии в области видеонаблюдения и цифровой обработки." />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://ommatid.com/" />
                <meta property="og:image" content="https://ommatid.com/preview.png" />
                <link rel="canonical" href="https://ommatid.com/" />
            </HelmetAny>
            <section className="main">
                <Photo data={photos} />
                <Grid
                    data={advantages}
                    classParent='advantages'
                />
                <Products />
                <Presentation />
            </section>
        </>
    )
}

export default Main;